import api from "@/api/url";

export default {
    namespaced: true,

    state: () => {
        return {
            paymentHistory: [],
            pageData: {
                currentPage: 1,
                totalPages: 0,
                pageSize: 0,
                total: 0,
            },
            savedCards: [],
            subscriptionInfo: {
                currency: "",
                nextBillingDate: "",
            },
        };
    },

    getters: {
        paymentHistory: state => state.paymentHistory,
        savedCards: state => state.savedCards,
        pageData: state => state.pageData,
        subscriptionInfo: state => state.subscriptionInfo,
    },

    mutations: {
        set(state, [key, value]) {
            state[key] = value;
        },
    },
    
    actions: {
        updatePaymentRecords({ state, commit }, payload) {
            commit("set", ["paymentHistory", [ payload, ...state.paymentHistory ]]);
            commit("set", ["pageData", {
                ...state.pageData,
                total: state.pageData.total + 1,
                totalPages: Math.ceil((state.pageData.total + 1) / state.pageData.pageSize),
            }]);
        },

        fetchPaymentRecords({ commit, state }, { refresh = false, params }) {
            if (state.paymentHistory?.length && !refresh) {
                return;
            }            

            return api.subscription.getPaymentHistory(params)
                .then((res) => {
                    const data = res.data.data;
                    
                    commit("set", ["paymentHistory", data.data]);
                    commit("set", ["pageData", {
                        ...state.pageData,
                        ...data.pageDetails,
                    }]);
                });
        },

        setPaymentRecords({ commit, state }, payload) {            
            commit("set", ["paymentHistory", [ payload, ...state.paymentHistory ]]);
        },

        getPaymentRecord(_, id) { 
            return api.subscription.getSinglePayment(id)
                .then((resp) => {
                    const data = resp?.data?.data;
                    return data;
                });
        },

        getInvoiceRecord(_, id) { 
            return api.subscription.getSingleInvoice(id)
                .then((resp) => {
                    const data = resp?.data?.data;
                    return data;
                });
        },

        // SUBSCRIPTION CARDS ----------
        fetchSavedCards({ commit, state }) {
            if (state.savedCards?.length) {
                return;
            }            

            return api.subscription.getCards()
                .then((res) => {
                    const data = res.data.data;                    
                    commit("set", ["savedCards", data]);
                });
        },

        removeCard({ state, commit }, id) {
            return api.subscription.removeCard(id)
                .then((resp) => {
                    const savedCards = state.savedCards;
                    const updatedSavedCards = savedCards.filter(c => c._id !== id);

                    commit("set", ["savedCards", updatedSavedCards]);
                });
        },

        // SUBSCRIPTION PLANS INFO ----------
        getSubscriptionInfo({ commit, state }) { 
            if (state.subscriptionInfo?.currency) {
                return state.subscriptionInfo;
            }
                       
            return api.subscription.getSubscriptionInfo()
                .then((resp) => {
                    // commit("set", ["subscriptionInfo", resp?.data?.data[0]]);
                    commit("set", ["subscriptionInfo", resp?.data?.data]);
                    return resp.data.data;
                });
        },

        updateSubscriptionPlan(_, payload) {            
            return api.subscription.updateSubscriptionPlan(payload)
                .then((resp) => {
                    return resp.data.data;
                });
        },

        updateSubscriptionInfo(_, payload) {            
            return api.subscription.updateSubscriptionInfo(payload?._id, payload)
                .then((resp) => {
                    return resp.data.data;
                });
        },

        initiateCharge(_, payload) {            
            return api.subscription.initiateCharge(payload)
                .then((resp) => {
                    return data.data.url;
                });
        }, 

        verifyCharge({ commit, state }, payload) {            
            return api.subscription.verifyCharge(payload)
                .then((resp) => {
                    if (payload.encryptedType === "dcdahsygh") {
                        commit("set", ["subscriptionInfo", { ...state.subscriptionInfo, ...resp.data.data.subscription }]);
                    } else {
                        commit("set", ["savedCards", [resp.data.data.card, ...state.savedCards]]);
                    }
                    console.log({ savedCards: resp.data });
                    
                    return resp.data;
                });
        },

        fetchInvoice(_, id) {            
            return api.subscription.getInvoice(id)
                .then((resp) => {                    
                    return resp.data.data;
                });
        },

        setSubscriptionInfo({ commit, state }, payload) {            
            commit("set", ["subscriptionInfo", { ...state.subscriptionInfo, ...payload }]);
        },

        cancelPaidPlan({ commit, state }) {            
            return api.subscription.cancelPlan()
                .then((resp) => {
                    commit("set", ["subscriptionInfo", { ...state.subscriptionInfo, ...resp.data.data?.subscription }]);
                });
        },
    },
};